(function ($) {
  $('input:checked').parent().addClass('checked');

  $('form :checkbox').on('change', function () {
    $(this).parent().toggleClass('checked', this.checked);
  }).trigger('checked');

  $('form :radio').on('change', function () {
    var $this = $(this),
      name = $this.attr('name');

    $('input[name=' + name + ']').parent().removeClass('checked');
    $(this).parent().addClass('checked');
  });

  $(document).on('click', '.burger-menu-filter .btn', function (e) {
    e.preventDefault();

    var $this = $(this),
      $form = $this.parents('.form'),
      $formModal = $form.find('.form-modal');

    $this.toggleClass('open');
    $formModal.toggleClass('open');
  });

  $(document).on('click', '.form .btn-back', function (e) {
    e.preventDefault();

    var $this = $(this),
      $form = $this.parents('.form'),
      $formModal = $form.find('.form-modal'),
      $btnFilter = $form.find('.burger-menu-filter button');

    $btnFilter.removeClass('open');
    $formModal.removeClass('open');
  });

  $(document).on('click', '.btn-switch', function () {
    var $this = $(this),
      name = $this.data('name');

    $('.btn-switch[data-name=' + name + ']').removeClass('checked');
    $this.addClass('checked');
  });

  $(document).on('keyup', '.btn-checkbox', function (e) {
    var $this = $(this);
    if (e.key === 'Enter') {
      $this.trigger('click');
    }
  });

  $(document).on('click', 'form .btn-clear', function () {
    var $this = $(this),
      $form = $this.parents('.form');

    $form.find('input[type=text],input[type=search]').val('');
    $form.find('input[type="checkbox"]').prop('checked', false);
    $form.find('.checked:not(button)').removeClass('checked');

    setTimeout(function () {
      $form.submit();
    }, 100);

    setTimeout(function () {
      $form.find('.form-modal').removeClass('open');
      $form.find('.burger-menu-filter button').removeClass('open');
    }, 200);
  });

  $(document).on('change', 'form .submit-onchange', function () {
    $(this).parents('form').submit();
  });

  // disable invalid event form subs
  $(document).ready( function () {
    if(!window.isValidEvent) {
      $('#event-registration-form').css('display', 'none');
    }
  });

  $('input[name="s"]').on('input', function() {
    const cleanValue = $(this).val().replace(/<[^>]*>/g, '');
    $(this).val(cleanValue);
  });
})(jQuery);